import React from 'react'
import { StyledMainPageRightSection, StyledRightSectionTopTextSection, StyledRightSectionTopText, StyledRightSectionTopTextEmoji, StyledRightControlButtonSection, StyledRightControlBlueButton, StyledCardsSection, StyledSingleCards, StyledCardsNumberAndTextSection, StyledCardsNumber, StyledCardsText, StyledGraphSection, StyledRightSectionContent, StyledPieGraphSection } from './style.dashboard'
import { Icon } from "@iconify/react";
import { LineChart } from '@mui/x-charts/LineChart';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import Layouts from '../../Layouts/Layouts';



const Dashboard = () => {
  const size = {
    width: 300,
    height: 300,
  };
  const mobileOS = [
    {
      label: 'Android',
      value: 70.48,
    },
    {
      label: 'iOS',
      value: 28.8,
    },
    {
      label: 'Other',
      value: 0.71,
    },
  ];



  const valueFormatter = (item) => `${item.value}%`;
  // const data = {
  //   data: mobileOS,
  //   valueFormatter,
  // };

  const dataset = [
    { "date": "2025-06-01", "customers": 57 },
    { "date": "2025-06-02", "customers": 62 },
    { "date": "2025-06-03", "customers": 49 },
    { "date": "2025-06-04", "customers": 78 },
    { "date": "2025-06-05", "customers": 53 },
    { "date": "2025-06-06", "customers": 45 },
    { "date": "2025-06-07", "customers": 88 },
    { "date": "2025-06-08", "customers": 39 },
    { "date": "2025-06-09", "customers": 71 },
    { "date": "2025-06-10", "customers": 60 },
    { "date": "2025-06-11", "customers": 50 },
    { "date": "2025-06-12", "customers": 84 },
    { "date": "2025-06-13", "customers": 67 },
    { "date": "2025-06-14", "customers": 58 },
    { "date": "2025-06-15", "customers": 74 },
    { "date": "2025-06-16", "customers": 43 },
    { "date": "2025-06-17", "customers": 90 },
    { "date": "2025-06-18", "customers": 51 },
    { "date": "2025-06-19", "customers": 77 },
    { "date": "2025-06-20", "customers": 66 },
    { "date": "2025-06-21", "customers": 48 },
    { "date": "2025-06-22", "customers": 81 },
    { "date": "2025-06-23", "customers": 54 },
    { "date": "2025-06-24", "customers": 73 },
    { "date": "2025-06-25", "customers": 64 },
    { "date": "2025-06-26", "customers": 59 },
    { "date": "2025-06-27", "customers": 70 },
    { "date": "2025-06-28", "customers": 61 },
    { "date": "2025-06-29", "customers": 85 },
    { "date": "2025-06-30", "customers": 52 }
  ];

  const cardDetails = [
    {
      icons: <Icon icon="fluent-emoji:shopping-bags" width="60" height="60" />,
      cardNumber: "999",
      cardName: "Total Agencies"
    }, {
      icons: <Icon icon="fluent-emoji:shopping-bags" width="60" height="60" />,
      cardNumber: "999",
      cardName: "Total Agencies"
    }, {
      icons: <Icon icon="fluent-emoji:shopping-bags" width="60" height="60" />,
      cardNumber: "999",
      cardName: "Total Agencies"
    }, {
      icons: <Icon icon="fluent-emoji:shopping-bags" width="60" height="60" />,
      cardNumber: "999",
      cardName: "Total Agencies"
    }, {
      icons: <Icon icon="fluent-emoji:shopping-bags" width="60" height="60" />,
      cardNumber: "999",
      cardName: "Total Agencies"
    }, {
      icons: <Icon icon="fluent-emoji:shopping-bags" width="60" height="60" />,
      cardNumber: "999",
      cardName: "Total Agencies"
    },
  ]

  return (
    <>

      <Layouts>


        <StyledMainPageRightSection>
          <StyledRightSectionTopTextSection>
            <StyledRightSectionTopText>Hi, Welcome back </StyledRightSectionTopText>
            <StyledRightSectionTopTextEmoji><Icon icon="fluent-emoji:waving-hand" width="36" height="36" /></StyledRightSectionTopTextEmoji>
          </StyledRightSectionTopTextSection>

          <StyledRightControlButtonSection>
            <StyledRightControlBlueButton>Refresh Inactive Tickets</StyledRightControlBlueButton>

          </StyledRightControlButtonSection>
          <StyledRightSectionContent>

            <StyledCardsSection>
              {
                cardDetails.map((obj) => (
                  <StyledSingleCards>
                    <span>{obj.icons}</span>
                    <StyledCardsNumberAndTextSection>
                      <StyledCardsNumber>{obj.cardNumber}</StyledCardsNumber>
                      <StyledCardsText>{obj.cardName}</StyledCardsText>
                    </StyledCardsNumberAndTextSection>
                  </StyledSingleCards>
                ))
              }
            </StyledCardsSection>
            <StyledGraphSection>

              <LineChart
                xAxis={[{ data: ["2025-6-1", "2025-6-2", "2025-6-3", "2025-6-4", "2025-6-5", "2025-6-6", "2025-6-7", "2025-6-8", "2025-6-9", "2025-6-10"] }]}
                series={[
                  {
                    data: [(dataset.filter((data) => data.customers))],
                    // showMark: ({ index }) => index % 2 === 0,
                  },
                ]}
                height={400}
              />


            </StyledGraphSection>
            <StyledPieGraphSection>
              <PieChart

                series={[
                  {
                    data: mobileOS,
                    arcLabel: (item) => `${item.value}%`,
                    arcLabelMinAngle: 35,
                    highlightScope: { fade: 'global', highlight: 'item' },
                    faded: { innerRadius: 0, additionalRadius: -30, color: 'gray' },
                    valueFormatter,
                  },
                ]}
                sx={{
                  [`& .${pieArcLabelClasses.root}`]: {
                    fontWeight: 'bold',
                  },
                }}
                {...size}


              />

            </StyledPieGraphSection>
          </StyledRightSectionContent>


        </StyledMainPageRightSection>

      </Layouts>
    </>
  )
}

export default Dashboard


